$(document).ready(function () {

    scrolled();
    telformat();
    anchorextension();
    scrolltolink();
    togglebodyclass();
    anchorlink();
    toggleleftmenu();

    
    emptyZeilenwrapper();
    $(window).scroll(function() {
        setTimeout(function() {
            scrolled();
        }, 100);
    });



    setTimeout(function(){
            akkordeon();
        }, 1500
    );

     
   
});



function scrolled(){
    //var headerheight =  $("#headerwrapper").height();
    var headerheight =  300;
    var height = 300;
    if(headerheight > 300){
        height = headerheight;
    }
    //console.log(headerheight);       
    if ($(this).scrollTop() > height) { 
        if(!$('body').hasClass('scrolled') ){ 
            $("body").addClass("scrolled");
        }
    } else {
        if($('body').hasClass('scrolled') ){
            $('body').removeClass('scrolled');
        }
    }
 
}



function emptyZeilenwrapper(){
    $(".DNNEmptyPane").closest(".zeilenwrapper").addClass("empty");
}

function akkordeon(){
    $title = $(".akkordeon .moduletitle"); 
    $($title).each( function(){
        $(this).click(function(){
            if ($(this).hasClass("open")){
                console.log("open");
                $(this).removeClass("open");
                $(this).parent().find("div.DNNModuleContent").hide("slow");
            } else {
                $(this).addClass("open");
                $(this).parent().find("div.DNNModuleContent").show("slow");
            }
        });
    });
    /* open Accordeon if #xy in URL*/
    if (location.hash) {
        targetArray = location.hash.split('#');
        var target = "#" + targetArray[1];
        //console.log("akkordeon");
        if( $(target).length){
            $(target).parents(".DnnModule").find("h2.moduletitle").addClass("open");
            $(target).parents(".DnnModule").find("div.DNNModuleContent").show("slow");
            smoothScrollTo(target);
        } 
    }
}

function togglebodyclass(){
    $($(".togglebodyclass")).each( function(){
        $(this).click(function(){
            var bodyclass = $(this).data("bodyclass");
            if ($("body").hasClass(bodyclass)){
                $("body").removeClass(bodyclass);
            } else {
                $("body").addClass(bodyclass);
            }
        });
    });
}

function toggleleftmenu(){
    $(".menutoggle").click(function(){
        if ($(".menu-wrapper").hasClass("expanded")){
            $(".menu-wrapper").removeClass("expanded");
        } else {
            $(".menu-wrapper").addClass("expanded");
        }
    });
}

function telformat(){
    /* macht aus +41 763 78 66 69 -> +41763786669 für den tel: link
             oder   076 378 66 69 -> +41763786669 */
    $('.telefonnummer').each(function(){ 
        var telnr = $(this).text().replace(/ /g,'');
        var erstenummer = telnr.substring(0,1);
        
        if(erstenummer==0){
            telnr = "+41"+telnr.substring(1);

        }

        $(this).attr("href", "tel:"+telnr); 
    });
}

function anchorextension(){
    /* Anchor created in HTML-Module with Editor */
    $('.DNNModuleContent.ModDNNHTMLC a').each(function(){
        if( $(this).attr('id') ){
            if(  $(this).attr('id') == $(this).attr('name')  ){
                $(this).addClass("glitmoduleanchor");
            }
        }
    });
    /* make Modulanchor visible in editor */
    $(".DnnModule .w5 > a.glitmoduleanchor").each(function(){
        if( $(this).attr('id') ){
            var id = $(this).attr('id');
            //console.log("id"+id);
            $(this).attr('name',id);
        }
    });
}

function smoothScrollTo(targetid) {
    if (targetid.length) {
        var target = $(targetid);
        $('html,body').animate({
            scrollTop: target.offset().top-90
        }, 1000);
    }
}

function scrolltolink() {
    $(".scrolltolink").each(function(){
        $(this).click(function(){
            var targetid = $(this).data("target");
            smoothScrollTo(targetid);
        });
    });
}

function anchorlink() {
    /* If Anchorlink is on same page (onClick) */
    // taken from: https://css-tricks.com/snippets/jquery/smooth-scrolling/
    $('a[href*=#]:not([href=#])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            
            smoothScrollTo($(this.hash));

            /* If its an Akkordeon, open it */
            var url= $(this).attr('href');
            targetArray = url.split('#');
            target = "#" + targetArray[1];

            if( $(target).parents(".DnnModule").hasClass("akkordeon") ) {
                $(target).parents(".DnnModule").find("h2.moduletitle").addClass("open");
                $(target).parents(".DnnModule").find("div.DNNModuleContent").show("slow");
            } 
            return false;
        }
    });

}